<div class="header-container">
    <div class="logo-container">
      <a (click)="toggleSidebar()" href="#" class="sidebar-toggle">
        <nb-icon icon="menu-2-outline"></nb-icon>
      </a>
      <a class="logo" href="#" (click)="navigateHome()"><img src="/assets/images/kwikstoreLogoFullBlack.png" alt="kwikstorelogo"></a>
    </div>
    <nb-select [selected]="currentTheme" (selectedChange)="changeTheme($event)" status="primary">
      <nb-option *ngFor="let theme of themes" [value]="theme.value"> {{ theme.name }}</nb-option>
    </nb-select>
  </div>
  
  <div class="header-container">
    <nb-actions size="small">
      <nb-action class="custom-action" link="pages/try-it-for-free" (click)="navigateLink($event)" title="try it fro free"><button nbButton status="success" link="pages/try-it-for-free">Try for free</button></nb-action>
      <nb-action class="custom-action" link="pages/price"(click)="navigateLink($event)" title="price">Pricing</nb-action>
      <nb-action class="custom-action" link="pages/blog" (click)="navigateLink($event)" title="try it fro free">Blog</nb-action>
      <nb-action class="custom-action">About Us</nb-action>
      <nb-action class="control-item">
        <nb-search type="rotate-layout"></nb-search>
      </nb-action>
      <nb-action class="control-item" icon="email-outline"></nb-action>
      <nb-action class="control-item" icon="bell-outline"></nb-action>
      <nb-action class="user-action" *nbIsGranted="['view', 'user']" >
        <nb-user [nbContextMenu]="userMenu"
                 [onlyPicture]="userPictureOnly"
                 [name]="user?.name"
                 [picture]="user?.picture">
        </nb-user>
      </nb-action>
    </nb-actions>
  </div>
  
